// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `code[class*='language-'],
pre[class*='language-'] {
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    color: #90a4ae;
    background: #fafafa;
    font-family: Roboto Mono, monospace;
    font-size: 1em;
    line-height: 1.5em;

    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;

    -webkit-hyphens: none;
    hyphens: none;
}

code[class*='language-']::-moz-selection,
pre[class*='language-']::-moz-selection,
code[class*='language-'] ::-moz-selection,
pre[class*='language-'] ::-moz-selection {
    background: #cceae7;
    color: #263238;
}

code[class*='language-']::-moz-selection, pre[class*='language-']::-moz-selection, code[class*='language-'] ::-moz-selection, pre[class*='language-'] ::-moz-selection {
    background: #cceae7;
    color: #263238;
}

code[class*='language-']::selection,
pre[class*='language-']::selection,
code[class*='language-'] ::selection,
pre[class*='language-'] ::selection {
    background: #cceae7;
    color: #263238;
}

:not(pre) > code[class*='language-'] {
    white-space: normal;
    border-radius: 0.2em;
    padding: 0.1em;
}

pre[class*='language-'] {
    overflow: auto;
    position: relative;
    margin: 0.5em 0;
    padding: 1.25em 1em;
}

.language-css > code,
.language-sass > code,
.language-scss > code {
    color: #f76d47;
}

[class*='language-'] .namespace {
    opacity: 0.7;
}

.token.atrule {
    color: #7c4dff;
}

.token.attr-name {
    color: #39adb5;
}

.token.attr-value {
    color: #f6a434;
}

.token.attribute {
    color: #f6a434;
}

.token.boolean {
    color: #7c4dff;
}

.token.builtin {
    color: #39adb5;
}

.token.cdata {
    color: #39adb5;
}

.token.char {
    color: #39adb5;
}

.token.class {
    color: #39adb5;
}

.token.class-name {
    color: #6182b8;
}

.token.comment {
    color: #aabfc9;
}

.token.constant {
    color: #7c4dff;
}

.token.deleted {
    color: #e53935;
}

.token.doctype {
    color: #aabfc9;
}

.token.entity {
    color: #e53935;
}

.token.function {
    color: #7c4dff;
}

.token.hexcode {
    color: #f76d47;
}

.token.id {
    color: #7c4dff;
    font-weight: bold;
}

.token.important {
    color: #7c4dff;
    font-weight: bold;
}

.token.inserted {
    color: #39adb5;
}

.token.keyword {
    color: #7c4dff;
}

.token.number {
    color: #f76d47;
}

.token.operator {
    color: #39adb5;
}

.token.prolog {
    color: #aabfc9;
}

.token.property {
    color: #39adb5;
}

.token.pseudo-class {
    color: #f6a434;
}

.token.pseudo-element {
    color: #f6a434;
}

.token.punctuation {
    color: #39adb5;
}

.token.regex {
    color: #6182b8;
}

.token.selector {
    color: #e53935;
}

.token.string {
    color: #f6a434;
}

.token.symbol {
    color: #7c4dff;
}

.token.tag {
    color: #e53935;
}

.token.unit {
    color: #f76d47;
}

.token.url {
    color: #e53935;
}

.token.variable {
    color: #e53935;
}
`, "",{"version":3,"sources":["webpack://./src/components/editor/prism-light.css"],"names":[],"mappings":"AAAA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mCAAmC;IACnC,cAAc;IACd,kBAAkB;;IAElB,gBAAgB;IAChB,cAAc;IACd,WAAW;;IAEX,qBAAqB;IAGrB,aAAa;AACjB;;AAEA;;;;IAII,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IAII,mBAAmB;IACnB,cAAc;AAClB;;AANA;;;;IAII,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["code[class*='language-'],\npre[class*='language-'] {\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    word-wrap: normal;\n    color: #90a4ae;\n    background: #fafafa;\n    font-family: Roboto Mono, monospace;\n    font-size: 1em;\n    line-height: 1.5em;\n\n    -moz-tab-size: 4;\n    -o-tab-size: 4;\n    tab-size: 4;\n\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n}\n\ncode[class*='language-']::-moz-selection,\npre[class*='language-']::-moz-selection,\ncode[class*='language-'] ::-moz-selection,\npre[class*='language-'] ::-moz-selection {\n    background: #cceae7;\n    color: #263238;\n}\n\ncode[class*='language-']::selection,\npre[class*='language-']::selection,\ncode[class*='language-'] ::selection,\npre[class*='language-'] ::selection {\n    background: #cceae7;\n    color: #263238;\n}\n\n:not(pre) > code[class*='language-'] {\n    white-space: normal;\n    border-radius: 0.2em;\n    padding: 0.1em;\n}\n\npre[class*='language-'] {\n    overflow: auto;\n    position: relative;\n    margin: 0.5em 0;\n    padding: 1.25em 1em;\n}\n\n.language-css > code,\n.language-sass > code,\n.language-scss > code {\n    color: #f76d47;\n}\n\n[class*='language-'] .namespace {\n    opacity: 0.7;\n}\n\n.token.atrule {\n    color: #7c4dff;\n}\n\n.token.attr-name {\n    color: #39adb5;\n}\n\n.token.attr-value {\n    color: #f6a434;\n}\n\n.token.attribute {\n    color: #f6a434;\n}\n\n.token.boolean {\n    color: #7c4dff;\n}\n\n.token.builtin {\n    color: #39adb5;\n}\n\n.token.cdata {\n    color: #39adb5;\n}\n\n.token.char {\n    color: #39adb5;\n}\n\n.token.class {\n    color: #39adb5;\n}\n\n.token.class-name {\n    color: #6182b8;\n}\n\n.token.comment {\n    color: #aabfc9;\n}\n\n.token.constant {\n    color: #7c4dff;\n}\n\n.token.deleted {\n    color: #e53935;\n}\n\n.token.doctype {\n    color: #aabfc9;\n}\n\n.token.entity {\n    color: #e53935;\n}\n\n.token.function {\n    color: #7c4dff;\n}\n\n.token.hexcode {\n    color: #f76d47;\n}\n\n.token.id {\n    color: #7c4dff;\n    font-weight: bold;\n}\n\n.token.important {\n    color: #7c4dff;\n    font-weight: bold;\n}\n\n.token.inserted {\n    color: #39adb5;\n}\n\n.token.keyword {\n    color: #7c4dff;\n}\n\n.token.number {\n    color: #f76d47;\n}\n\n.token.operator {\n    color: #39adb5;\n}\n\n.token.prolog {\n    color: #aabfc9;\n}\n\n.token.property {\n    color: #39adb5;\n}\n\n.token.pseudo-class {\n    color: #f6a434;\n}\n\n.token.pseudo-element {\n    color: #f6a434;\n}\n\n.token.punctuation {\n    color: #39adb5;\n}\n\n.token.regex {\n    color: #6182b8;\n}\n\n.token.selector {\n    color: #e53935;\n}\n\n.token.string {\n    color: #f6a434;\n}\n\n.token.symbol {\n    color: #7c4dff;\n}\n\n.token.tag {\n    color: #e53935;\n}\n\n.token.unit {\n    color: #f76d47;\n}\n\n.token.url {\n    color: #e53935;\n}\n\n.token.variable {\n    color: #e53935;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
